import { Box, Menu, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .LRMBtn': {
    color: theme.palette.common.white,
    padding: theme.spacing(1.25),
    marginRight: theme.spacing(1),
    fontSize: theme.spacing(2.5),
  },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.8),
    border: `1px solid ${alpha(theme.palette.common.white, 0.24)}`,
    borderRadius: theme.spacing(1),
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 0),
    boxShadow: `0px 0px 50px 0px ${theme.palette.divider[7]}`,
    backdropFilter: `blur(${theme.spacing(1)})`,
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      width: theme.typography.pxToRem(532),
    },
  },
  '& .LRTabs': {
    padding: theme.spacing(0.5, 2, 0, 2),
    borderBottom: `1px solid ${theme.palette.divider[7]}`,
    '& .MuiTabs-indicator': {
      height: theme.typography.pxToRem(1),
      backgroundColor: theme.palette.common.white,
    },
  },
  '& .LRTab': {
    color: theme.palette.common.white,
    fontWeight: 400,
    fontSize: theme.spacing(2),
    '&.Mui-selected': {
      fontWeight: 500,
    },
  },
  '& .LRTabsSections': {
    padding: theme.spacing(2, 2, 1.5, 2),
  },
  '& .LRMenuItem': {
    padding: theme.spacing(1.125, 1.625),
    fontWeight: 500,
    fontSize: theme.spacing(2),
    border: '1px solid transparent',
    '&:hover, &.LRMenuItemSelected': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.divider[3],
      borderRadius: theme.spacing(0.75),
    },
  },
  '& .LRCurrencyName': {
    fontWeight: 400,
    marginLeft: theme.spacing(1),
    color: alpha(theme.palette.common.white, 0.8),
  },
}));

export default StyledBox;
